import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BundledDownloadsBaseComponent } from "@mypxplat/xplat/features";
import { UserService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-bundled-downloads",
  templateUrl: "bundled-downloads.component.html",
  standalone: false,
})
export class BundledDownloadsComponent extends BundledDownloadsBaseComponent implements OnInit {
  public s1OrNotion: boolean;
  public showAllBundledDownloads: boolean;
  public myOs: string;
  @Input() downloadableContent: any[];
  @Input() showAllSystems: boolean;
  @Input() product: any;

  // Soundsets group content, split by the `platform` tag buildDownloadableContent attaches
  // (the bucket key it came from: "all"/"mac"/"win"/"win64"/...) — mirrors the shape the old
  // `bundledDownloads.{all,mac,win64,win}` object had, just sourced from downloadableContent.
  public allItems: any[] = [];
  public macItems: any[] = [];
  public win64Items: any[] = [];
  public winItems: any[] = [];

  constructor(
    userService: UserService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (this.product.licenseScheme == 1) {
      this.showAllBundledDownloads = true;
    }

    this.myOs = this.appService.os;

    const soundsets: any[] = (this.downloadableContent || []).find((g) => g.type === "Soundsets")?.content || [];
    this.allItems = soundsets.filter((item) => item.platform === "all");
    this.macItems = soundsets.filter((item) => item.platform === "mac");
    this.win64Items = soundsets.filter((item) => item.platform === "win64");
    this.winItems = soundsets.filter((item) => item.platform === "win");

    this.s1OrNotion = this.product.categoryId == "software" && (this.product.stringId.indexOf("studioapp") > -1 || this.product.licenseScheme == 1) ? true : false;
  }
  showHideDownloads(event: any) {
    this.showAllBundledDownloads = !this.showAllBundledDownloads;
    event.preventDefault();
  }
}
